import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, SplitButton, SplitButtonItemClickEvent } from '@progress/kendo-react-buttons';
import { ITicketProps } from '../../../../../../types/Ticket/ITicket';
import { UserApi } from '../../../../../../redux/api/UserApi';
import { useReduxDispatch, useReduxSelector } from '../../../../../../redux/hooks';
import { SetSelectedActions } from '../../../../../../slices/SelectedActionsSlice';
import * as svg from '@progress/kendo-svg-icons';
import { isMobile } from 'react-device-detect';
import { setActionExpanded } from '../../../../../../slices/TicketDetailUISlice';

const AddEventButton: React.FC<ITicketProps> = (ticket) => {
    const selectedActions = useReduxSelector(state => state.selectedActionsStore.selectedActions);
    const { data: userProfile } = UserApi.useGetUserProfileQuery();
    const thisTicketActionsSelected = selectedActions?.filter(a => a.ticketId === ticket.ID);
    const navigate = useNavigate();
    const dispatch = useReduxDispatch();
    const actionExpanded = useReduxSelector(state => state.ticketDetailsUI.actionExpanded);

    const eventButtonClicked = () => {
        if (isMobile)
            navigate('event');
        else
            dispatch(setActionExpanded(actionExpanded !== 3 ? 3 : 0));
    }

    return (<>
        <Button disabled={ticket.Is_Loading} className='related-button' onClick={eventButtonClicked} title={`Add Calendar Event`} svgIcon={svg.calendarIcon}
            size='large' ></Button>
    </>
    );
};

export default AddEventButton;